import { create } from 'zustand';

import { BreadcrumbExtra } from '@/interfaces';

interface BreadcrumbStore extends BreadcrumbExtra {
  setBreadcrumbExtras: (extras: BreadcrumbExtra) => void;
  clearBreadcrumbExtras: () => void;
}

export const useBreadcrumbStore = create<BreadcrumbStore>((set) => ({
  labelOverrides: undefined,
  extraItems: undefined,
  setBreadcrumbExtras: (extras) => set(extras),
  clearBreadcrumbExtras: () => set({ labelOverrides: undefined, extraItems: undefined }),
}));
